import {
    createChatInputPanelComponent,
} from '@vfde-brix/chat-input-panel';
import { ID_WEBCHAT_INPUT_PANEL } from 'Container/Ui/constants';
import { renderChatBubbles } from 'Container/Ui/helpers/renderWebchatBubbles';
import { scrolldown } from './scrolldown';

/**
 * make it public because i
 */
let chatInputPanel;

/**
 * return chatInputPanel
 * @param actionSendMessage
 * @returns
 */
const mountChatInputPanel = (actionSendMessage: (message: string) => void, force = false) => {

    if (chatInputPanel && !force) {
        return chatInputPanel;
    }

    const wrapperChatInputPanel = document.getElementById(ID_WEBCHAT_INPUT_PANEL) as HTMLElement;

    const onSubmit = (_event, message) => {
        actionSendMessage(message);

        renderChatBubbles([message], true);
        scrolldown();
    };

    chatInputPanel = createChatInputPanelComponent(wrapperChatInputPanel, {
            business: {
                onSubmit,
            },
        });

    return chatInputPanel;

};

export default mountChatInputPanel;
